export default __webpack_public_path__ + "static/media/Arrow-down.5b4576ac.svg";